import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';
import { t, defineMessages } from '@sm/intl';
import { IconLogoGoldie } from '@sm/wds-icons';
import { useSurveyTheme, createSurveyStyles } from '@sm/webassets';
import checkDarkMode from '~app/helpers/luminance';
import './footer.scss';

const useStyles = createSurveyStyles(theme => {
  return {
    ctaLink: {
      color: theme?.secondaryAccentColor,
      backgroundColor: theme?.primaryAccentColor,
      fontFamily: theme?.questionBody?.fontFamily,
    },
  };
});

const DEFAULT_COPY = defineMessages({
  GET_STARTED: {
    id: 'Footer.GetStarted',
    defaultMessage: 'Get Started',
    description: '[Type: Button][Vis.: low] - Get Started Button',
  },
  ALL_SET: {
    id: 'Footer.AllSet',
    defaultMessage: 'All set! Now create your own interactive quiz.',
    description: '[Type: Text][Vis.: low] - All Set Info Message',
  },
});

const Footer = ({ isKiosk }) => {
  const theme = useSurveyTheme();
  const { ctaLink } = useStyles();
  const backgroundColor = theme.primaryBackgroundColor || '#fff';
  const isDarkMode = checkDarkMode(backgroundColor);
  const goldieLogoColor = isDarkMode ? 'dark-muted' : 'primary';
  const ctaColor = isDarkMode ? 'black' : 'primary';

  if (isKiosk) {
    return null;
  }
  return (
    <footer className="sm-footer--container">
      <div className="sm-footer--content">
        <a className="sm-footer--logo" href="/?ut_source=quiz_results" target="_blank" rel="noreferrer">
          <IconLogoGoldie size="xl" color={goldieLogoColor} />
        </a>
        <div className="sm-footer--text">
          <span className="sm-footer--content">{t(DEFAULT_COPY.ALL_SET)}</span>
          <span>
            <Button
              size="md"
              className={ctaLink}
              color={ctaColor}
              target="_blank"
              href="/create/?create=scratch&quiz=true&ut_source=quiz_results"
              rel="noreferrer"
            >
              {t(DEFAULT_COPY.GET_STARTED)}
            </Button>
          </span>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  isKiosk: PropTypes.bool,
};

Footer.defaultProps = {
  isKiosk: false,
};

export default Footer;
